import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ToolbarPageLayoutService {
  private _showOptions$ = new BehaviorSubject(false);
  private _disableOptions$ = new BehaviorSubject(false);
  private _showFilters$ = new BehaviorSubject(false);
  private _showCharts$ = new BehaviorSubject(false);
  private _showOptionsButton$ = new BehaviorSubject(false);
  private _showFiltersButton$ = new BehaviorSubject(false);
  private _showChartsButton$ = new BehaviorSubject(false);
  private _showPageHeader$ = new BehaviorSubject(false);
  
  showOptions$ = this._showOptions$.asObservable();
  disableOptions$ = this._disableOptions$.asObservable();
  showFilters$ = this._showFilters$.asObservable();
  showCharts$ = this._showCharts$.asObservable();

  showPageHeader$ = this._showPageHeader$.asObservable();
  showOptionsButton$ = this._showOptionsButton$.asObservable();
  showFiltersButton$ = this._showFiltersButton$.asObservable();
  showChartsButton$ = this._showChartsButton$.asObservable();

  toggleShowOptions = () => {
    this._showOptions$.next(!this._showOptions$.getValue());
  };

  toggleShowPageHeader = () => {
    this._showPageHeader$.next(this._showPageHeader$.getValue());
  };
  toggleShowFilters = () => {
    this._showFilters$.next(!this._showFilters$.getValue());
  };

  toggleShowCharts = () => {
    this._showCharts$.next(!this._showCharts$.getValue());
  };

  setDisableOptions(disable: boolean) {
    this._disableOptions$.next(disable);
  }

  setOptionsVisibility(value: boolean) {
    this._showOptions$.next(value);
  }

  setOptionsButtonVisibility(value: boolean) {
    this._showOptionsButton$.next(value);
  }

  setFilterButtonVisibility(value: boolean) {
    this._showFiltersButton$.next(value);
  }
  
  setHeaderVisibility(value: boolean) {
    this._showPageHeader$.next(value);
  }

  setChartsButtonVisibility(value: boolean) {
    this._showChartsButton$.next(value);
  }
}
